import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useAuth } from "react-use-auth"
import { Link } from "rebass"
import Layout from "./layout"

import { default as PleaseLoginCopy } from "./please-login"
import PleasePurchase from './please-purchase'
import Head from "./head"
import { isAdditionalCoursePage } from "../util"
import { getGumroadPricing } from "./Gumroad"

const additionalCourseQuery = graphql`
  query {
    site {
      siteMetadata {
        additionalCourses {
            title
            slug
            gumroadCode
        }
      }
    }
  }
`


const PleaseLogin = (props) => {
  const { login } = useAuth()
  return (
    <>
      <Head {...props} />
      <main
        id="content"
        style={{
          textAlign: "center",
          margin: "auto auto",
        }}
      >
        Please{" "}
        <Link href="" onClick={login}>
          login
        </Link>{" "}
        to access this page
        <PleaseLoginCopy />
      </main>
    </>
  )
}

export const ScopedRoute = ({ scopes, element, ...props }) => {
  const { isAuthenticated, isAuthorized, user } = useAuth()

  const data = useStaticQuery(additionalCourseQuery)

  if (scopes.includes("Demo")) {
    return (
      <Layout authorized={true} fullwidth={false} {...props}>
        {element}
      </Layout>
    )
  } else if (isAuthorized(scopes)) {
    return (
      <Layout authorized={true} fullwidth={false} {...props}>
        {element}
      </Layout>
    )
  } else if (isAuthenticated()) {
    // Check to see if there is an additional course
    if (data.site?.siteMetadata?.additionalCourses) {
      for (var course of data.site.siteMetadata.additionalCourses) {
        const { title, gumroadCode, slug } = course
        if (isAdditionalCoursePage(props.location, slug)) {
          return (
            <Layout authorized={false} fullwidth={true} {...props}>
              <PleasePurchase additionalCourse title={title} code={gumroadCode} />
            </Layout>
          )
        }
      }
    }
    
    // If the user is authenticated but not authorized, we offer an upgrade
    const gumroadPricing = getGumroadPricing(user, scopes)

    return (
      <Layout authorized={false} fullwidth={true} {...props}>
        <PleasePurchase {...gumroadPricing} />        
      </Layout>
    )
  } else {
    return (
      <Layout authorized={false} fullwidth={true} {...props}>
        <PleaseLogin />
      </Layout>
    )
  }
}
